export default "__VITE_ASSET__fX8ZpOcO__"